<template>
  <ai-carousel-overflow-item
    :title="title"
    :description="description"
    :picture="picture"
    :lazy-load-picture="lazyLoadImage"
    :detail-link="ctaUrl"
    image-clickable="link">
    <template #top>
      <ai-pictograms
        v-if="pictogramsUrl"
        icon-position="center"
        color="white"
        :size="40"
        variant="positive"
        :url="pictogramsUrl" />
    </template>

    <template #button>
      <ai-button
        v-if="ctaUrl"
        :aria-label="
          $t('homepage.experiencesCarousel.ariaLabel', { collection: title })
        "
        as-link
        :href="ctaUrl"
        class="HomeExperienceCategoriesCarouselItem-button"
        variant="tertiary"
        :label="$t('homepage.experiencesCarousel.button')"
        slim
        light
        icon-right="button-arrow-right" />
    </template>
  </ai-carousel-overflow-item>
</template>

<script setup lang="ts">
import type { AiPicture } from '~~/domains/graphql';

interface Props {
  title: string;
  description: string;
  ctaLabel: string;
  picture: AiPicture;
  pictogramsUrl: string;
  ctaUrl?: string;
  lazyLoadImage: boolean;
}

defineProps<Props>();
</script>

<style scoped lang="scss">
@use '@/assets/styles/utilities/constants';

.HomeExperienceCategoriesCarouselItem-button {
  margin-top: constants.$margin-02;
}
</style>
